// extracted by mini-css-extract-plugin
module.exports = {"lang":"LanguageSwitch_lang__3Zg14","selected":"LanguageSwitch_selected__10AJA"};